import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import ReportStages from "../ReportStages";
import { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../Services/Account/EncryptionParams";
import TransferItemInformationEmployee from "../TransferItemInformationEmployee";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";

const ReportStagesPage = () => {
  const RefreshWorkFlow = useSelector((state)=>state.WorkFlowReducer.WorkFlowResult)
  const dispatch=useDispatch()
  const navigate = useNavigate();
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const [PopupComponentTransferStatus, setPopupComponentTransferStatus] =
    useState(false);
  const [applicationInformationGuid, setApplicationInformationGuid] =
    useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ReportStatusByApplicationGuid:
        state.TransferItemInformation.ReportStatusByApplicationGuid,
      RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
    };
  });
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestsColumns = [];

  const RequestAccessor = [
    {
      KeyName: "stagesName",
      ShowStatus: true,
      NmaeColumn: "المرحلة الحالية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "dateCreate",
      ShowStatus: true,
      NmaeColumn: "تاريخ تقديم الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "currentStageStatus",
      ShowStatus: true,
      NmaeColumn: "حالة المرحلة الحالية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        localStorage.setItem("aI_ApplicationInformationId_Manager", e.target.value)
        setApplicationInformationGuid(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "التقارير المرحلية",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        localStorage.setItem("aI_ApplicationInformationId_Manager", e.target.value)
        let token = encryptToken(e.target.value);
        navigate(`/grants/manager/PrepareProgressReport/${token}`);
      },
      content: "",
      className: "bi bi-sliders",
      id: "editBtn",
      title: "التقارير المرحلية",
      ShowStatus: state.RoleByUserGuid?.includes(
        "f8decae8-ba89-484c-94f6-22c64996266a"
      )||state.RoleByUserGuid?.includes(
        "45ab458b-7479-4b83-bf88-49a9cd65226d"
      ) ? true : false,
      PrepareProgressReport: true,
    },
    {
      Click: async (e) => {
        localStorage.setItem("aI_ApplicationInformationId_Manager", e.target.value)
        setApplicationInformationGuid(e.target.value);
        closePopupTransferComponent();
      },
      content: "",
      className: "bi bi-arrow-left-right",
      id: "editBtn",
      title: "المناقلات",
      ShowStatus:

        state.RoleByUserGuid?.includes(
          "26e2191c-69f4-49fb-9a69-e76ed7693bb5"
        ) ? true : false,
      PrepareProgressReport: false,
    },
    {
      Click: async (e) => {
        localStorage.setItem("aI_ApplicationInformationId_Manager", e.target.value)

        let token = encryptToken(e.target.value);
        navigate(`/grants/manager/ReportSummaryPage/${token}`);
      },
      content: "",
      className: "bi bi-suitcase-lg",
      id: "editBtn",
      title: "الملخص",
      ShowStatus: true,
      PrepareProgressReport: false,
    }
    // {
    //     Click: async (e) => {

    //        navigate(`/grants/ReportStageContainer/${encryptToken(e.target.value)}`);
    //     },
    //     content: "",
    //     className: "bi bi-sliders",
    //     id: "editBtn",
    //     title: "عرض",
    //     ShowStatus: true,
    //     PrepareProgressReport:true
    // }
  ];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => { },
    componentBody: <></>,
    maxWidth: "700px",
    maxHeight: "800px",
    title: "الأهداف",
  };

  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };

  const closePopupTransferComponent = () => {
    if (PopupComponentTransferStatus) {
      setPopupComponentTransferStatus(false);
    } else {
      setPopupComponentTransferStatus(true);
    }
  };
  useEffect(() => {
      dispatch(setRefreshTable());
  }, [RefreshWorkFlow]);
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName={state.jsonData ? state.jsonData.RS_Report.nameAR : ""} // Display the translated title of the time frame information
        child={[
          <TableAHSF
            culomEdite={culomEdite}
            uniqueValue={"aI_ApplicationInformationId"}
            valueButtonAction={"aI_ApplicationInformationId"}
            URL={`api/PR_Reports/GetAllRports`}
            // UrlBody={{
            //     aI_ApplicationInformationId: "",
            // }}
            staticKeyEdite={staticKeyEdite}
            accessor={RequestAccessor}
            titelTable={""}
            selectRowNumber={true}
            checkBoksColumName="اختيار"
            sort={true}
            pagination={true}
            AppStatus={true}
            // tableBtn={!shouldDisableFields}
            sortTable={true}
            keyNameSort={"dateCreate"}
            dateKey="dateCreate"
            dateformat="DD/MM/YYYY h:mm a"
            arrayNameSort={["applicationNumber"]}
            search={true}
            openPopupState={false}
            DropdownArrayFiltration={[]}
            DropdownFiltration={false}
            exportData={true}
            checkBoks={false}
            nameColumAction=""
            total={false}
            arrayButton={OtherMainBtns}
            ArrayNameDataColum={RequestsColumns}
            columnKeyNameArray={[
              { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
            ]}
            PopupOPjectData={PopupOPjectData}
            popUpTitle={"معلومات الطلب"}
          />,
        ]} // Display the TimeFrameInformation component
        showButton={true}
        id_Title="PrepareProgressReport"
      />

      <PopupAHSF
        title={"المراحل"}
        componentBody={
          <ReportStages
            applicationInformationGuid={applicationInformationGuid}
            view={true}
          />
        }
        maxWidth="1000px"
        maxHeight="1200px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />

      <PopupAHSF
        title={"المناقلات"}
        componentBody={
          //   <ReportStages
          //     applicationInformationGuid={applicationInformationGuid}
          //     view={true}
          //   />
          <TransferItemInformationEmployee
            applicationInformationGuid={applicationInformationGuid}
          />
        }
        maxWidth="1000px"
        maxHeight="1200px"
        isPopupOpenStatus={PopupComponentTransferStatus}
        isPopupOpenFunction={closePopupTransferComponent}
      />
    </>
  );
};
export default ReportStagesPage;
